import './../../entities/project-action';
export const companyActionDtoFields = [
    {
        name: "project",
        title: "Progetto",
        render: (record) => record.codiceProgetto
    }, {
        name: "codiceAzione",
        title: "Codice Azione",
        render: (record) => record.codiceAzione
    }, {
        name: "descrizioneAzione",
        title: "Descrizione Azione",
        render: (record) => record.descrizioneAzione
    }, {
        name: "codiceCommessa",
        title: "Codice Commessa",
        render: (record) => record.codiceCommessa
    }
];
